export default "__VITE_ASSET__DBFauM9u__"